import { useContext } from "react";
import {
  ActivePracticeContext,
  PracticesContext,
} from "../../contexts/contextExporter";
import CodeShiki from "../../components/CodeShiki";

// Bu kadar yanlış denemeden sonra "Cevabı gör" çıkar
export const REVEAL_AFTER_WRONG = 5;

// Footer butonları: 5 yanlıştan sonra "Cevabı gör", cevap görüldükten sonra
// puansız olarak sonraki soruya geçiş (cevap görülünce gönderim kapanır).
export function RevealAnswerButton({
  tryAgain,
  isLive,
}: {
  tryAgain: () => void;
  isLive: boolean;
}) {
  const {
    actionStatus,
    setActionStatus,
    wrongAnswerCount,
    isAnswerRevealed,
    setIsAnswerRevealed,
    isInstructor,
  } = useContext(ActivePracticeContext);
  const { nextPractice, isLastPractice } = useContext(PracticesContext);

  if (isInstructor || actionStatus.canGoNext) return null;

  if (!isAnswerRevealed) {
    if (wrongAnswerCount < REVEAL_AFTER_WRONG || actionStatus.ai !== "IDLE")
      return null;
    return (
      <button
        type="button"
        className="practice-button bg-myGb/50"
        onClick={() => {
          tryAgain();
          setIsAnswerRevealed(true);
        }}
      >
        Cevabı gör
      </button>
    );
  }

  const skip = () => {
    // Canlı derste son soruda nextPractice part'ı ilerletir; onun yerine
    // "Tebrikler" ekranını göster (canGoNext + IDLE).
    if (isLive && isLastPractice) {
      setActionStatus({ ai: "IDLE", canGoNext: true, historyIndex: -1 });
    } else {
      nextPractice();
    }
  };

  return (
    <button
      type="button"
      className="practice-button bg-myGreen/80 border border-myGreen text-black/80 ml-auto hover:bg-myGreen"
      onClick={skip}
    >
      Sonraki Soru (puansız)
    </button>
  );
}

export function RevealedAnswerBox({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="bg-myGb/40 rounded-2xl p-5 pt-6">
      <p className="mb-4 pl-1">
        Doğru cevap bu. İnceleyip anladıktan sonra bu soruyu puansız geçebilirsin.
      </p>
      {children}
    </div>
  );
}

export function RevealedAnswerCode({ code }: { code: string }) {
  return (
    <RevealedAnswerBox>
      <CodeShiki code={code} cx="code2shiki" />
    </RevealedAnswerBox>
  );
}

export function RevealedSandpackAnswer() {
  const { practice } = useContext(ActivePracticeContext);
  const answerFiles =
    practice?.type === "REACT" ? practice.description.answerFiles : undefined;
  if (!answerFiles) return null;

  return (
    <RevealedAnswerBox>
      <div className="space-y-4">
        {Object.keys(answerFiles).map((s) => (
          <div key={s}>
            <p className="mb-1 pl-1 text-sm text-white/60">{s}</p>
            <CodeShiki
              code={
                typeof answerFiles[s] === "string"
                  ? answerFiles[s]
                  : answerFiles[s].code
              }
              cx="code2shiki"
            />
          </div>
        ))}
      </div>
    </RevealedAnswerBox>
  );
}
